import type { SubHeaderProps } from './SubHeader.types';

import React from 'react';
import { useSelector } from 'react-redux';
import * as selectors from 'features/sessions/selectors';
import { SubHeaderButton } from '../Buttons';
import { SessionSectionType } from '../../Session.constants';
import './_sub-header.scss';

export const SubHeader = ({
  sectionType,
  isSessionCompleted,
  isHotkeyDisabled,
  onExplainModalToggle,
  onCalculatorModalToggle,
  onCalculatorToggle,
  onFlagToggle,
  onInstructionsToggle,
}: SubHeaderProps) => {
  const currentQuestionResponse = useSelector(selectors.selectCurrentQuestionResponse);

  // On the Review Prescore summary the toolbar shows only Instructions
  // (no Calculator / Flag) — matching the real exam.
  if (sectionType === SessionSectionType.REVIEW_PRESCORE) {
    return (
      <React.Fragment>
        <div className="sub-header__container">
          <div className="sub-header__buttons">
            <SubHeaderButton
              type="instructions"
              onClick={onInstructionsToggle(true)}
              isHotkeyDisabled={isHotkeyDisabled}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="sub-header__container">
        {!isSessionCompleted && (
          <React.Fragment>
            <div className="sub-header__buttons">
              {isSessionCompleted && sectionType === SessionSectionType.QUESTION && (
                <SubHeaderButton type="answer" onClick={onExplainModalToggle(true)} />
              )}

              {currentQuestionResponse && (
                <SubHeaderButton
                  type="calculator"
                  onClick={onCalculatorToggle}
                  isHotkeyDisabled={isHotkeyDisabled}
                />
              )}
            </div>

            {sectionType === SessionSectionType.QUESTION && currentQuestionResponse && (
              <div className="sub-header__buttons">
                <SubHeaderButton
                  type="flag"
                  flagged={Boolean(currentQuestionResponse?.flagged)}
                  isHotkeyDisabled={isHotkeyDisabled}
                  onClick={onFlagToggle}
                />
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};
